export const ATTRACTION_TYPE = 'attraction'
export const HOTEL_TYPE = 'hotel'

export function determineItemType(types: string[] = []) {
  if (types.includes('lodging') && types.includes('establishment')) {
    return HOTEL_TYPE
  }
  return ATTRACTION_TYPE
}
